export default {
      id: "Icon--fullscreen-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--fullscreen",
      toString: function () {
        return this.url;
      }
    }